// extracted by mini-css-extract-plugin
export var closeButton = "_l4-1";
export var closeX = "_l4-3";
export var container = "_l4-0";
export var image = "_l4-2";